/**
 * Default social / Open Graph copy tuned for LinkedIn previews
 * (clear hook early; description aligned with SERP length, professional tone).
 * Keep public/index.html OG tags aligned when changing these strings.
 */

export const OG_IMAGE = {
  path: "/og-image.png",
  width: 1200,
  height: 630,
  alt: "Jamil Global — registered in the UAE, expanding to Kuwait — agents and automations that ship across the GCC",
};

/** Primary line — brand + commercial intent; keep ~50–60 chars for SERP. */
export const DEFAULT_SOCIAL_TITLE =
  "Jamil Global | AI Agents & Automations for Kuwait & GCC";

/** Subline — outcome-led; ~150–160 chars for SERP/snippets (OG can match). */
export const DEFAULT_SOCIAL_DESCRIPTION =
  "Jamil Global builds AI agents, workflow automations, and AI integrations. An AI studio registered in the UAE and expanding to Kuwait, serving the GCC.";